import { jsx as _jsx } from "react/jsx-runtime";
import globalStore from '../store';
import PlayerMainContainer from './PlayerMainContainer';
import { MathJaxContext } from 'better-react-mathjax';
import '../helper/i18n';
import { StrictMode } from 'react';
var Player = function () {
    var StoreProvider = globalStore.Provider;
    return (_jsx(StrictMode, { children: _jsx(StoreProvider, { children: _jsx(MathJaxContext, { config: {
                    loader: { load: ['input/asciimath'] },
                    menuSettings: { inTabOrder: false },
                    options: {
                        enableMenu: false,
                        renderActions: {
                            addMenu: [], // Disable menu rendering
                        },
                        menuOptions: {
                            settings: {
                                assistiveMml: false, // true to enable assistive MathML
                                collapsible: false, // true to enable collapsible math
                                explorer: false, // true to enable the expression explorer
                            },
                        },
                    },
                }, version: 3, children: _jsx(PlayerMainContainer, {}) }) }) }));
};
export default Player;
